import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Loader from "../Components/Cargando";
import { API_BASE_URL } from "../Utils/apiConfig";

function Protected({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        
        const token = localStorage.getItem('JWT');
        const response = await axios.get(`${API_BASE_URL}/api/check-auth`, {
          headers: {
            Authorization: `Bearer ${token}`
                    },
        });
        setIsAuthenticated(response.data.isAuthenticated);
        setIsLoading(false);
      } catch (error) {
        console.error("Error al verificar la autenticación:", error);
        setIsAuthenticated(false);
        setIsLoading(false);
      }
    };
    
    checkAuth();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

Protected.propTypes = {
  children: PropTypes.node,
};

export default Protected;
